import { render, staticRenderFns } from "./News.vue?vue&type=template&id=91b8307e"
import script from "./News.js?vue&type=script&lang=js&external"
export * from "./News.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports